import { render, staticRenderFns } from "./FacilidadesReporte.vue?vue&type=template&id=ebd1043e&"
import script from "./FacilidadesReporte.vue?vue&type=script&lang=js&"
export * from "./FacilidadesReporte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports